<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Filo Kodu</label>
            <v-validator :errors="errors" parameter="FleetCode" :watch="value.FleetCode">
              <input type="text" class="form-control" placeholder="Filo Kodu" v-model="value.FleetCode"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Filo Adı</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
              <input type="text" class="form-control" placeholder="Filo Adı" v-model="value.Name"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Kaynak Filo Adı</label>
            <v-validator :errors="errors" parameter="OriginalName" :watch="value.OriginalName">
              <input type="text" class="form-control" placeholder="Kaynak Filo Adı" v-model="value.OriginalName"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <v-validator :errors="errors" parameter="Description" :watch="value.Description">
              <input type="text" class="form-control" placeholder="Açıklama" v-model="value.Description"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    },
}
</script>

<style>

</style>